import { makeRequest } from 'utils/requestLogger';

const joinCourse = (inviteInfo) =>
  makeRequest('post', '/api/courses/join', inviteInfo).then(
    (resp) => resp.data
  );

export default joinCourse;



// WEBPACK FOOTER //
// ./src/app/services/courses/joinCourse.js